import { memo, useCallback, useRef } from 'react';
import { useRouter } from 'next/router';

import { useAppDispatch, useAppSelector } from 'hooks/useRedux';
import { toggleIsVerifiedBox } from 'store/slices/global';
import { useLogout } from 'hooks/useLogout';
import Text from '../common/text';
import { HeaderAccountWrapper } from './styles';
import VerifyEmail from '../verify-email';
import { DASHBOARD_ROUTE } from 'constants/routes';
import { userSelector } from 'store/slices/auth/selector';
import { globalSelector } from 'store/slices/global/selector';

function HeaderAccount() {
  const { logout } = useLogout();
  const router = useRouter();
  const dispatch = useAppDispatch();
  const { data, jwt } = useAppSelector(userSelector);
  const accountRef = useRef<HTMLDivElement>(null);
  // const { isOpen, toggle } = useToggle(accountRef);
  const { isVerifiedBox } = useAppSelector(globalSelector);

  const handleViewMyProfile = useCallback(() => {
    if (data?.isVerified) {
      router.push({ pathname: DASHBOARD_ROUTE });
    } else {
      dispatch(toggleIsVerifiedBox());
    }
  }, [data?.isVerified, router, dispatch]);

  return (
    <>
      <HeaderAccountWrapper
        className="account"
        ref={accountRef}
        // onClick={toggle}
      >
        <div className="account-avatar" onClick={handleViewMyProfile}>
          <Text type="mode4" fw="medium">
            {data?.fullName[0]}
          </Text>
        </div>
        <div className="account-logout" onClick={logout}>
          <Text fw="bold">Log out</Text>
        </div>
        {/* <div className="account-info">
          <Text type="mode4" fw="medium">
            {data?.fullName}
          </Text>
          <NextImage
            src="/static/icons/arrow-down.svg"
            width={20}
            height={20}
          />
        </div> */}

        {/* <AnimatePresence>
          {isOpen && (
            <motion.div
              className="account-dropdown"
              variants={fade}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <div
                className="account-dropdown-item"
                onClick={handleViewMyProfile}
              >
                <NextImage
                  src="/static/icons/user.svg"
                  width={24}
                  height={24}
                />
                <Text type="mode4">View My Profile</Text>
              </div>
              <div
                className="account-dropdown-item"
                onClick={() => dispatch(removeUser())}
              >
                <NextImage
                  src="/static/icons/logout.svg"
                  width={24}
                  height={24}
                />

                <Text type="mode4">Sign Out</Text>
              </div>
            </motion.div>
          )}
        </AnimatePresence> */}
      </HeaderAccountWrapper>
      {jwt && !data?.isVerified && isVerifiedBox && <VerifyEmail />}
    </>
  );
}

export default memo(HeaderAccount);
